/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { theme, themeV2, coloredScrollBar, pxToEm } from '@insticator/insticator-ui';



/* ++++++++++ --------------- STACKED CHARTS : STYLES --------------- ++++++++++ */
export default {
    barchart: {
        overflowX: 'auto',
        overflowY: 'hidden',
        paddingBottom: pxToEm(6),
        height: pxToEm(400),
        marginBottom: pxToEm(10),
        marginRight: pxToEm(24),
        extend: coloredScrollBar(themeV2.color.base.scrollbar)
    }
};
